// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__gtOpc","label":"Radio_label__jL7ZX","checkMark":"Radio_checkMark__1QqH4","disabled":"Radio_disabled__2vH3g"};